import { FormControl } from '@mui/material';
import React from 'react';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { FormBodyAPI } from 'src/constants/fieldsTypes';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BaseTextField } from 'src/legacy/components/TextField';

interface FormValues {
  label: string;
  value: string;
}

export const useAddCheckboxForm = () => {
  const validationScheme = Yup.object().shape({
    label: Yup.string().trim().max(4000, 'Maximum 4000 characters'),
    value: Yup.string().oneOf(['true', 'false']).required(),
  });

  const getSubmitValues = () => Promise.resolve({ key: v4() });

  const FormRenderer: React.FC<FormBodyAPI<FormValues>> = ({
    touched,
    errors,
    handleChange,
    handleBlur,
  }) => {
    return (
      <div>
        <FormControl fullWidth>
          <BaseTypography fontType="13Medium">Label</BaseTypography>
          <BaseTextField
            name="label"
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={touched.label && errors.label ? errors.label : ''}
            variant="outlined"
            error={Boolean(touched.label && errors.label)}
            inputProps={{
              'data-testid': 'checkbox-label-input',
              maxLength: 4000,
            }}
            autoFocus
          />
        </FormControl>
      </div>
    );
  };

  return { validationScheme, getSubmitValues, FormRenderer };
};
